import ActYearRookie from '@/assets/jce/ActYearRookieMatchServant.js';
import { fetchProd, getURLParam } from '@tools/func.ts';
import { data } from './data.js';

import "./wsChannel";
declare global {
  interface Window {
    Taf: any
  }
}
// const staticClose = getURLParam('mock') !== '1';
const staticClose = false;
const Taf = window.Taf || null;
const callWup: (
  moduleName: string,
  funcName: string,
  data: any,
  unpackFun: any
) => Promise<any> = (moduleName, funcName, data, unpackFun) => {
  const TestURL = "http://testws.va.huya.com?timestamp=";
  const ProdURL = "https://cdnws.api.huya.com?timestamp=";
  const URL = fetchProd() ? ProdURL : TestURL;
  const wup = new Taf.Wup();
  wup.setServant(moduleName);
  wup.setFunc(funcName);
  wup.writeStruct("tReq", data);
  const buffer = wup.encode().getBuffer();
  const timestamp = new Date().getTime();
  return new Promise((resolve, reject) => {
    Taf.Util.ajax(
      URL + timestamp,
      buffer,
      (value: any) => {
        const rsp = new Taf.Wup();
        rsp.decode(value);
        const result = new unpackFun();
        rsp.readStruct("tRsp", result, unpackFun);
        // console.log(funcName, data, result);
        resolve(result);
      },
      (res: any) => {
        reject(res);
      }
    );
  });
};
const tafFetch = (moduleName: string, data: any, requ: any, resp: any) => {
  const req = requ === null ? null : new requ();
  Object.keys(data).forEach((key) => {
    req[key] = data[key];
  });
  return callWup("wupui", moduleName, req, resp);
};

const random = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min)) + min;
}

const RankItemMock: (count: number) => RankItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    let lUid = random(9999999, 100000);
    data.push({
      lUid,
      iRank: i + 1,       // 排名
      lScore: random(0, 99999999),      // 分数
      sNickName: random(0, count) + '随机昵称随机昵称',   // 昵称
      sLogoUrl: '',    // 头像
      tJump: {
        lPid: lUid,       // 主播Uid
        lTid: 0,          // 频道Tid
        lSid: 0,          // 频道Sid
        iGameId: 0,       // 品类id
        lYYId: 0,         // YY
        iRoomId: random(0, 99999),    // roomid
        iLive: random(0, 99999999) % 2 === 0 ? 0 : 1,      // 是否在播
      },
      iPromoteStatus: 0,
      sDesc: '娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开',
      iStarIdol: 0,
      sPortraitUrl: '',
    })
  }
  data = data.sort((prev, next) => next.lScore - prev.lScore);
  for (let i = 0; i < count; i++) {
    data[i].iRank = i + 1;
  }
  return data;
}

const HourTopItemMock: (count: number) => HourTopItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    let lUid = random(9999999, 100000)
    data.push({
      sNickName: random(0, count) + '随机昵称随机昵称',   // 昵称
      sLogoUrl: '',    // 头像
      sDesc: '随机描述' + random(0, count),
      tJump: {
        lPid: lUid,       // 主播Uid
        lTid: 0,          // 频道Tid
        lSid: 0,          // 频道Sid
        iGameId: 0,       // 品类id
        lYYId: 0,         // YY
        iRoomId: random(0, 99999),    // roomid
        iLive: random(0, 99999999) % 2 === 0 ? 0 : 1,      // 是否在播
      },
    })
  }
  return data;
}

const GuildItemMock: (count: number) => GuildItem[] = count => {
  let data = [];
  for (let i = 0; i < count; i++) {
    data.push({
      iRank: i + 1,
      lScore: random(0, 99999999),      // 分数,
      lCompanyId: random(0, 99999999),
      sCompanyLogoUrl: '',    // 头像
      sCompanyName: '随机描述' + random(0, count),
      sDesc: random(0, 99999999) % 2 === 0 ? '' : '公会描述啊公会描述啊公会描述啊公会描述啊公会描述啊',
      vRank: {
        value: RankItemMock(20),
      },
    })
  }
  return data;
}


/*
   enum RankAreaURI
    {
        kGame           = 1,     // 巅峰公会赛:游戏, 公会全明星:端游
        kEntertainment  = 2,     // 巅峰公会赛:娱乐, 公会全明星:综合娱乐
        kMobileGame     = 3,     // 手游
        kStar           = 4,     // 星秀
        kFace           = 5,     // 颜值
        kGold           = 6,     // 金牌公会(巅峰公会赛决赛会用)
    };
*/

/* 公共结构体 */
export interface RankItem {
  lUid: number,        // 主播uid
  iRank: number,       // 排名
  lScore: number,      // 分数
  sNickName: string,   // 昵称
  sLogoUrl: string,    // 头像
  tJump: JumpChannel,       // 跳转
  iArea?: number,       // 主播所属分组
  iPromoteStatus?: number //淘汰标识
}
export interface JumpChannel {
  lPid: number,       // 主播Uid
  lTid: number,       // 频道Tid
  lSid: number,       // 频道Sid
  iGameId: number,    // 品类id
  lYYId: number,      // YY
  iRoomId: number,    // roomid
  bIsLive: number,      // 是否在播
}

// 获取阶段
type GetStageReq = (
  option: {
    lPid: number,
    iActId: number,
  }
) => Promise<GetStageRsp>

export interface GetStageRsp {
  iStage: number, // 当前赛程
  iDay: number, // 当前赛程下第几天
  iArea: number,  // 参考@RankAreaURI
}

const getStage: GetStageReq = option => {
  if (staticClose) return tafFetch('getStage20201202', option, ActYearRookie.GetStageReq, ActYearRookie.GetStageRsp);
  return new Promise(resolve => {
    // resolve({
    //   iStage: 5,
    //   iDay: 2,
    //   iArea: 2,
    // })
    resolve(data.getStage)
  })
}



// 小时榜单
type GetHourRankReq = (
  option: {
    iStage: number,
    iAreaId: number,
    iActId: number
  }
) => Promise<GetHourRankRsp>

export interface GetHourRankRsp {
  iCurStage: number,  // 当前赛程
  vRank: {        // 主播小时榜
    value: RankItem[],
  },
  vHourRank: {   // 游戏小时冠军
    value: RankItem[],
  },
  tPidRank: RankItem, // 当前主播游戏小时榜排行
}

export interface HourTopItem {
  sNickName: string,
  sLogoUrl: string,
  sDesc: string,
  tJump: JumpChannel,
}

const getHourRank: GetHourRankReq = option => {
  if (staticClose) return tafFetch('getHourRank20201202', option, ActYearRookie.GetHourRankReq, ActYearRookie.GetHourRankRsp);
  return new Promise(resolve => {
    // resolve({
    //   iCurStage: 2,
    //   vRank: {
    //     value: RankItemMock(50),
    //   },
    //   vHourRank: {
    //     value: RankItemMock(10),
    //   },
    //   tPidRank: RankItemMock(1)[0],
    // })
    resolve(data.getHourRank['iStage' + option.iStage]['iArea' + option.iAreaId])
  })
}


// 游戏、娱乐榜单
type GetAuditionRankReq = (
  option: {
    iStage: number,
    iAreaId: number,
    iActId: number
    lPid?: number
  }
) => Promise<GetAuditionRankRsp>

export interface GetAuditionRankRsp {
  tPanel: StageRankPanel
}

export interface StageRankPanel {
  iAreaId: number,
  vRankList: { // 榜单列表
    value: RankItem[],
  }
  iGroupId: number,
}

export interface HourTopItem {
  sNickName: string,
  sLogoUrl: string,
  sDesc: string,
  tJump: JumpChannel,
}

const GetAuditionRank: GetAuditionRankReq = option => {
  if (staticClose) return tafFetch('getAuditionRank20201202', option, ActYearRookie.GetAuditionRankReq, ActYearRookie.GetAuditionRankRsp);
  return new Promise(resolve => {
    // resolve({
    //   tPanel: {
    //     iAreaId: 11,
    //     vRankList: {
    //       value: RankItemMock(10),
    //     },
    //     iGroupId: 1221,
    //   }
    // })
    resolve(data.getAuditionRank['iStage' + option.iStage]['iArea' + option.iAreaId]);
  })
}

// 神豪榜
type richReq = (
  option: {}
) => Promise<GetRichRankRsp>
export interface GetRichRankRsp {
  vRank: {
    value: RankItem[],
  },
}
const getRichRank: richReq = option => {
  if (staticClose) return tafFetch('getRichRank20201202', option, ActYearRookie.GetRichRankReq, ActYearRookie.GetRichRankRsp);
  return new Promise(resolve => {
    // resolve({
    //   vRank: {
    //     value: RankItemMock(50),
    //   },
    // })
    resolve(data.getRichRank)
  })
}

// 获取报名页信息
type getSignUpPageReq = (
  option: {
    lPid: number,
  }
) => Promise<getSignUpPageRsp>
export interface getSignUpPageRsp {
  iContestant: number, // 0为参赛者 -1为未参赛者
  iTeamup: number, // 0为已组队 -1为未组队
  tRookie?: PresenterBase,
  tHelper?: PresenterBase,
  vMembers?: {
    value: PresenterBase[]
  }
}

export interface PresenterBase {
  tJump: JumpChannel,
  sNickName: string,
  sLogoUrl: string,
}
const getSignUpPage: getSignUpPageReq = option => {
  if (staticClose) return tafFetch('getSignUpPage', option, ActYearRookie.getSignUpPageReq, ActYearRookie.getSignUpPageRsp);
  return new Promise(resolve => {
    resolve({
      iContestant: 0,
      iTeamup: 0,
    })
  })
}


// 接收邀请
type AcceptInviteReq = (
  option: {
    lPid: number,
    lInvitedPid: number
  }
) => Promise<AcceptInviteRsp>
export interface AcceptInviteRsp {
  iRet: number, // 0 成功, -1 失败
}
const acceptInvite: AcceptInviteReq = option => {
  if (staticClose) return tafFetch('acceptInvite', option, ActYearRookie.AcceptInviteReq, ActYearRookie.AcceptInviteRsp);
  return new Promise(resolve => {
    resolve({
      iRet: 0,
    })
  })
}

// 邀请未参赛主播
type SearchHelperReq = (
  option: {
    lPid: number,
    sHyId: string
  }
) => Promise<SearchHelperRsp>
export interface SearchHelperRsp {
  ifind: number, // 0 成功搜索 -1 未找到该id
  iRet: number, //-1：已经邀请 0:未邀请
  tInfo?: PresenterBase, //应援对象信息
}
const SearchHelper: SearchHelperReq = option => {
  if (staticClose) return tafFetch('SearchHelper', option, ActYearRookie.SearchHelperReq, ActYearRookie.SearchHelperRsp);
  return new Promise(resolve => {
    resolve({
      ifind: 0,
      iRet: 0,
    })
  })
}

// 发送邀请
type InvitePresenterReq = (
  option: {
    lInvitedPid: number,
    lPid: number
  }
) => Promise<InvitePresenterRsp>
export interface InvitePresenterRsp {
  iRet: number, // 0 成功 -1失败
}
const invitePresenter: InvitePresenterReq = option => {
  if (staticClose) return tafFetch('invitePresenter', option, ActYearRookie.InvitePresenterReq, ActYearRookie.InvitePresenterRsp);
  return new Promise(resolve => {
    resolve({
      iRet: 0,
    })
  })
}


const fetch = {
  getStage,
  getHourRank,
  getRichRank,
  GetAuditionRank,
  getSignUpPage,
  acceptInvite,
  SearchHelper,
  invitePresenter
}
export {
  fetch,
  RankItemMock,
}
